import { formatDuration as fmtDuration, intervalToDuration } from "date-fns";
import { ensureUtc } from "../utils";

export const formatDuration = (
  startedAt: string,
  finishedAt: string | null
): string => {
  if (!finishedAt) return "—";
  const start = new Date(ensureUtc(startedAt));
  const end = new Date(ensureUtc(finishedAt));
  if (end.getTime() - start.getTime() < 1000) return "<1s";
  return fmtDuration(intervalToDuration({ start, end }));
};

/**
 * Color mapping for each peril code
 */
const PERIL_CODE_COLORS: Record<string, string> = {
  PWH: "#2563eb", // Hurricane - Wind Only (blue)
  PSH: "#06b6d4", // Hurricane - Storm Surge (cyan)
  PES: "#a16207", // Earthquake - Ground Shake (amber)
  PSL: "#ca8a04", // Earthquake - Sprinkler Leakage (yellow)
  PFF: "#ea580c", // Earthquake - Fire Following (orange)
  PFL: "#0d9488", // Inland Flood (teal)
  PWB: "#dc2626", // Wildfire (red)
  PWW: "#38bdf8", // Winter Storm (icy blue)
  PWT: "#7c3aed", // Severe Thunderstorm (violet)
};

/**
 * Get color for a peril based on its code
 */
export const getPerilColor = (perilCode: string): string | undefined => {
  const code = perilCode.toUpperCase();
  if (code in PERIL_CODE_COLORS) {
    return PERIL_CODE_COLORS[code];
  }
  return undefined;
};
